<template>
  <div class="register-view" :style="{ '--height': height, }">
    <div class="index-view-top">
      <div class="logo"><img src="../assets/hash_logo.png" alt=""></div>
      <div class="title">{{ $t("head.luckyhash") }}</div>
      <van-icon name="ellipsis" size="28" color="#ffffff" style="opacity: 0" />
    </div>
    <div class="index-view-top">
      <van-icon name="arrow-left" @click="toBack" size="28" color="#ffffff" />
    </div>
    <div class="welcome">
      <div>{{ $t("register.forget") }}</div>
    </div>
    <div class="login-tips">{{ $t("register.login_tips") }}</div>
    <van-cell-group inset>
      <img class="left" src="../assets/1000.png" alt="" />
      <van-field v-model="account" :placeholder="tips1" />
    </van-cell-group>
    <van-cell-group inset>
      <img class="left" src="../assets/1004.png" alt="" />

      <van-field v-model="address" :placeholder="tips2" />
    </van-cell-group>
    <van-cell-group inset>
      <img class="left" src="../assets/1001.png" alt="" />
      <van-field v-model="password" :type="passwordType" :placeholder="tips3">
        <template #button><img v-if="passwordType == 'password'" class="password-show" src="../../static/hide.png"
            @click="changePasswordType" style="height:1rem" alt="" /><img v-else class="password-show"
            src="../../static/show.png" @click="changePasswordType" alt="" /></template>
      </van-field>
    </van-cell-group>
    <van-cell-group inset>
      <img class="left" src="../assets/1001.png" alt="" />
      <van-field v-model="confirmPassword" :type="confirmPasswordType" :placeholder="tips4">
        <template #button><img v-if="confirmPasswordType == 'password'" class="password-show"
            src="../../static/hide.png" @click="changeConfirmPasswordType" style="height:1rem" alt="" /><img v-else
            class="password-show" src="../../static/show.png" @click="changeConfirmPasswordType" alt="" /></template>
      </van-field>
    </van-cell-group>
    <div class="nowLogin">
      <div @click="toRegister">
        <p>{{ $t("register.confirmupdate") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  forgetPwd, login
} from "@/utils/request";
import identify from "../components/code"; //**引入验证码组件**
export default {
  components: {
    identify,
  },
  data() {
    return {
      account: "", //账号
      address: "",//账号绑定的钱包地址
      password: "", //密码
      confirmPassword: "", //确认密码
      inviteCode: "", //邀请码
      verificationCode: "", //验证码
      identifyCode: "",
      passwordType: "password",
      confirmPasswordType: 'password',
      height: '',//屏幕高度,
      tips1: '',
      tips2: '',
      tips3: '',
      tips4: '',//输入框提示
    };
  },
  //获取屏幕高度
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  mounted() {
    this.tips1 = this.$t("register.account")
    this.tips2 = this.$t("register.address")
    this.tips3 = this.$t("register.password")
    this.tips4 = this.$t("register.confirm")
    this.updateIdentifyCode();
  },
  methods: {
    toBack() {
      this.$router.go("-1");
    },
    toLogin() {
      this.$router.push("/");
    },
    //密码的显示与隐藏
    changePasswordType() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    //密码的显示与隐藏
    changeConfirmPasswordType() {
      if (this.confirmPasswordType == "password") {
        this.confirmPasswordType = "text";
      } else {
        this.confirmPasswordType = "password";
      }
    },
    //更新图形验证码
    updateIdentifyCode() {
      this.identifyCode = parseInt(Math.random() * 8999) + 1000 + 1 + "";
    },
    toRegister() {
      let _this = this;
      let reg2 =
        /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/;
      if (!reg2.test(_this.password)) {
        this.$toast(this.$t("register.password"));
      } else if (_this.password != _this.confirmPassword) {
        this.$toast(this.$t("register.two"));
      } else {
        forgetPwd({
          account: _this.account,
          address: _this.address,
          password: _this.password,
          confirmPassword: _this.confirmPassword,
        }).then((res) => {
          if (res.code == "200") {
            this.$toast.success(this.$t("register.update_success"))
            setTimeout(() => {
              login({
                account: _this.account,
                password: _this.password,
              }).then((res) => {
                if (res.code == "200") {
                  this.$toast.success(this.$t("register.loginsuccessful"));
                  localStorage.setItem("token", res.data.token);
                  this.$store.commit("changeUserName", this.account);
                  if (res.data.bindWalletStatus == true) {
                    setTimeout(() => {
                      this.$router.push("/luckyhash");
                    }, 500);
                  } else {
                    setTimeout(() => {
                      this.$router.push("/address");
                    }, 500);
                  }
                } else {
                  this.$toast.success(res.msg);
                }
              });
            }, 1000);
          } else {
            this.$toast.success(res.msg);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register-view {
  width: 100vw;
  height: var(--height);
  background: #020017;

  .verification {
    display: flex;

    .verification-image {
      width: 5.625rem;
      height: 2.5rem;
      border: 0.0625rem solid #484848;
    }
  }

  .password-show {
    display: block;
    height: 0.875rem;
  }

  .index-view-top {
    height: 3.125rem;
    display: flex;
    align-items: center;
    padding: 0 0.9375rem;

    .logo {
      >img {
        display: block;
        width: 2.8125rem;
        height: 2.1875rem;
      }
    }

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #C08D4E;
      padding-left: .625rem;
    }
  }

  .login-tips {
    font-size: 0.9375rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    padding: 0 1.875rem 2.1875rem;
  }

  .welcome {
    padding: 0.9375rem 1.875rem 0.9375rem;
    display: flex;

    >div {
      font-size: 1.25rem;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .no-account {
    display: flex;
    align-items: center;
    justify-content: center;

    >p {
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
    }

    >p:nth-child(1) {
      color: #999999;
    }

    >p:nth-child(2) {
      color: #ffffff;
    }
  }

  .nowLogin {
    padding: 0 1.875rem;
    margin-bottom: 0.9375rem;
    margin-top: 3rem;

    >div {
      width: 100%;
      height: 2.6875rem;
      background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
      border-radius: 1.375rem;
      display: flex;
      align-items: center;
      justify-content: center;

      >p {
        font-size: 0.9375rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #0c0b0b;
      }
    }
  }

  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: unset;
  }

  /deep/ .van-field__control {
    color: #ffffff !important;
  }

  .van-cell {

    background: #110E31;
    //border-radius: 1.375rem;
    padding-left: 0.5rem;
  }

  .van-cell-group {

    background: #110E31;
    border-radius: 1.375rem;
    margin: 0 1.875rem 1rem;
    display: flex;
    padding-left: 1rem;
    align-items: center;

    .left {
      width: 1.25rem;
      height: 1.25rem
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/forget.vue